import {apiV2Link} from "@pg-mono/rp-api-routes";
import {IPaginatedResponse} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IPaginatedRequest} from "../../types/IPaginatedRequest";
import {IGetPropertyListPayload} from "../types/GetPropertyListPayload";
import {IRecommendedProperty} from "../types/IRecommendedProperty";

type IGetRecommendedPropertiesPayload = IGetPropertyListPayload &
    Partial<IPaginatedRequest> & {
        propertyId: number;
        excludedOfferIds: number[];
        radius?: number;
    };

interface IGetRecommendedPropertiesResponse {
    results: IRecommendedProperty[];
}

export const getRecommendedPropertiesApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getRecommendedProperties: build.query<IGetRecommendedPropertiesResponse, IGetRecommendedPropertiesPayload>({
            query: ({propertyId, page = 1, page_size = 6, excludedOfferIds, ...params}) => ({
                url: apiV2Link.property.similar({propertyId}),
                params: {
                    page,
                    page_size,
                    exclude_offer: excludedOfferIds,
                    exclude_grouped: 1, // exclude offers from the same group of stages
                    ...params
                }
            }),
            transformErrorResponse: (response, _b, {page, page_size}) => {
                getIgnoredNotifyResponse(response, [404]);

                return {
                    page,
                    count: 0,
                    next: null,
                    previous: null,
                    page_size,
                    results: []
                } as IPaginatedResponse;
            }
        })
    })
});

export const {useGetRecommendedPropertiesQuery} = getRecommendedPropertiesApi;
export const {getRecommendedProperties} = getRecommendedPropertiesApi.endpoints;
import {apiV2Link} from "@pg-mono/rp-api-routes";
import {IPaginatedResponse} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IPaginatedRequest} from "../../types/IPaginatedRequest";
import {IGetPropertyListPayload} from "../types/GetPropertyListPayload";
import {IRecommendedProperty} from "../types/IRecommendedProperty";

type IGetRecommendedPropertiesPayload = IGetPropertyListPayload &
    Partial<IPaginatedRequest> & {
        propertyId: number;
        excludedOfferIds: number[];
        radius?: number;
    };

interface IGetRecommendedPropertiesResponse {
    results: IRecommendedProperty[];
}

export const getRecommendedPropertiesApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getRecommendedProperties: build.query<IGetRecommendedPropertiesResponse, IGetRecommendedPropertiesPayload>({
            query: ({propertyId, page = 1, page_size = 6, excludedOfferIds, ...params}) => ({
                url: apiV2Link.property.similar({propertyId}),
                params: {
                    page,
                    page_size,
                    exclude_offer: excludedOfferIds,
                    exclude_grouped: 1, // exclude offers from the same group of stages
                    ...params
                }
            }),
            transformErrorResponse: (response, _b, {page, page_size}) => {
                getIgnoredNotifyResponse(response, [404]);

                return {
                    page,
                    count: 0,
                    next: null,
                    previous: null,
                    page_size,
                    results: []
                } as IPaginatedResponse;
            }
        })
    })
});

export const {useGetRecommendedPropertiesQuery} = getRecommendedPropertiesApi;
export const {getRecommendedProperties} = getRecommendedPropertiesApi.endpoints;
